
export const formatNumber = (value: number|string) => {

    if (typeof value === 'string') {
        value = Number(value);
    }

    return new Intl.NumberFormat('es-ES').format(value);
}
